// extracted by mini-css-extract-plugin
module.exports = {"grid":"JobOfferPage_grid__1AXvV","gridItem":"JobOfferPage_gridItem__2Zf4W"};